import { render } from "./ProjectLayout.vue?vue&type=template&id=234ee5dc"
import script from "./ProjectLayout.vue?vue&type=script&lang=js"
export * from "./ProjectLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__